// extracted by mini-css-extract-plugin
module.exports = {"header":"FiltersModal_header__1BGr6","content":"FiltersModal_content__3MLWd"};